export default function SecurityGroupsViewController(
  $stateParams,
  $state,
  $scope,
  $uibModal,
  securityGroupsService,
  gettextCatalog,
) {
  'ngInject';

  $scope.onLoadErrorFlag = false;
  $scope.errorFlag = false;
  $scope.successFlag = false;
  $scope.onLoadErrorText = ''; //error text to display when group cannot be loaded
  $scope.errorText = ''; //error text for other error cases ie. detail update submission
  $scope.loading = true;
  $scope.data = {
    formEditing: false,
  };
  $scope.update = {};

  /** Edit/Cancel Button */
  $scope.editButtonClicked = function (editing) {
    populateUI();
  };

  /**
   * Loads the UI with the data that is stored in $scope.group
   */
  function populateUI() {
    $scope.securityGroupId = $stateParams.securityGroupId;
    $scope.securityGroupDesc = $scope.group.attrs.description ? $scope.group.attrs.description : '';
    $scope.securityGroupName = $scope.group.name;
    $scope.securityGroupTags = [];

    for (let i = 0; i < $scope.group.tags.length; i++) {
      $scope.securityGroupTags[i] = {
        text: $scope.group.tags[i],
      };
    }

    $scope.update.Name = $scope.securityGroupName;
    $scope.update.Desc = $scope.securityGroupDesc;
    $scope.update.Tags = $scope.securityGroupTags.slice();
  }

  if ($stateParams.securityGroupId) {
    securityGroupsService.getSingleGroup($stateParams.securityGroupId).then(
      function (response) {
        $scope.loading = false;
        $scope.group = response.data;

        //Refresh the UI with the returned data
        populateUI();

        $scope.$broadcast('groupLoaded');
      },
      function (error) {
        $scope.loading = false;
        if (!$state.$current.parent.self.ncyBreadcrumbLabel) {
          if ($scope.$parent.selectedRow) {
            $state.$current.parent.self.ncyBreadcrumbLabel = $scope.$parent.selectedRow;
          } else {
            $state.$current.parent.self.ncyBreadcrumbLabel = 'Error';
            $state.$current.parent.self.ncyBreadcrumbLink =
              $state.$current.parent.parent.self.ncyBreadcrumbLink;
          }
        }
        let errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving group information',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.onLoadErrorText = errorMsg;
        $scope.onLoadErrorFlag = true;
      },
    );
  } else {
    $scope.onLoadErrorFlag = true;
    $scope.onLoadErrorText = gettextCatalog.getString(
      'Could not load page: no security group ID provided.',
    );
  }

  $scope.existingNames = [];

  if ($scope.$parent.securityGroups) {
    for (let i = 0; i < $scope.$parent.securityGroups.length; i++) {
      $scope.existingNames.push($scope.$parent.securityGroups[i].name);
    }
  }
  $scope.$on('groupListLoaded', function () {
    for (let i = 0; i < $scope.$parent.securityGroups.length; i++) {
      $scope.existingNames.push($scope.$parent.securityGroups[i].name);
    }
  });

  $scope.nameExists = function () {
    if (!$scope.group) {
      return false;
    }
    for (let i = 0; i < $scope.existingNames.length; i++) {
      if (
        $scope.update.Name.toLowerCase() === $scope.existingNames[i].toLowerCase() &&
        !($scope.update.Name.toLowerCase() === $scope.group.name.toLowerCase())
      ) {
        return true;
      }
    }
    return false;
  };

  $scope.editing = false;
  $scope.nameDescUpdated = false; //true if name and description form inputs have been updated
  $scope.nameDescConfirmed = false; //true if name and description changes have been confirmed (user clicks check mark)

  $scope.submitDetails = function (form) {
    $scope.errorFlag = false;
    // I think some of this validation is redundant. Looks like $scope.update.Name is undefined if it is invalid.
    if (
      !$scope.update.Name ||
      $scope.update.Name.length === 0 ||
      $scope.sending ||
      form.name.$error.maxlength
    ) {
      return;
    }
    $scope.sending = true;
    //update only description and preserve other properties
    const attrs = { ...($scope.group.attrs || {}), description: $scope.update.Desc };
    const tags = $scope.update.Tags.map((t) => t.text);
    let data = {
      name: $scope.update.Name,
      attrs,
      tags,
    };

    securityGroupsService
      .putGroupUpdate($scope.securityGroupId, data)
      .then(function (response) {
        $scope.group = _.merge($scope.group, response.config.data);
        $scope.securityGroupDesc = $scope.group.attrs.description
          ? $scope.group.attrs.description
          : '';
        $scope.securityGroupName = $scope.group.name;
        $scope.group.tags = response.config.data.tags.slice();
        $scope.securityGroupTags = [];

        for (let i = 0; i < $scope.group.tags.length; i++) {
          $scope.securityGroupTags[i] = {
            text: $scope.group.tags[i],
          };
        }

        $scope.update.Name = $scope.securityGroupName;
        $scope.update.Desc = $scope.securityGroupDesc;
        $scope.update.Tags = $scope.securityGroupTags.slice();
        $scope.nameDescConfirmed = false;
        $scope.data.formEditing = false;
      })
      .catch(function (error) {
        let errorMsg = gettextCatalog.getString('An error occurred while editing group details');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
      })
      .finally(function () {
        $scope.sending = false;
      });
  };

  $scope.resetFlags = function () {
    $scope.successFlag = false;
    $scope.errorFlag = false;
  };

  $scope.deleteButtonPressed = function () {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('./delete-modal/_delete.modal.html'),
      controller: 'SecurityGroupViewDeleteModalController',
      resolve: {
        group: function () {
          return $scope.group;
        },
      },
      size: 'md',
    });
  };

  let groupMenuItems = [
    {
      title: gettextCatalog.getString('Manage Assets'),
      sref: 'admin.securitygroupbase.equipment({securityGroupId:securityGroupId})',
    },
    {
      title: gettextCatalog.getString('Manage Users'),
      sref: 'admin.securitygroupbase.users({securityGroupId:securityGroupId})',
    },
  ];

  $scope.groupMenuItems = groupMenuItems;

  $scope.isActiveState = function (state) {
    return true;
  };

  $scope.nameChanged = function () {
    window.dataLayer.push({
      event: 'securityEditNameChanged',
    });
  };

  $scope.descriptionChanged = function () {
    window.dataLayer.push({
      event: 'securityEditDescriptionChanged',
    });
  };

  $scope.TagAdded = function () {
    $scope.resetFlags();
    GTM_TagsChanged('securityEditTagAdded');
  };

  $scope.TagRemoved = function () {
    $scope.resetFlags();
    GTM_TagsChanged('securityEditTagRemoved');
  };

  function GTM_TagsChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.update.Tags.length,
      },
    });
  }
}
